import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { BillingServiceService } from './billing-service.service';
import { LoadingService } from './services/loading.service';
import { NgxLoadingModule } from 'ngx-loading';
import { LocalStorageService } from './services/local-storage.service';
import { SpeedDialModule } from 'primeng/speeddial';
import { MenuItem } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MainMenuComponent } from "./main-menu/main-menu.component";
import { CampaignServiceService } from './campaign-service.service';

type LangOption = { img: string, text: string, shortText: string, value: string, icon: string };

@Component({
  selector: 'app-root',
  providers: [
    BillingServiceService, CampaignServiceService, LocalStorageService
  ],
  imports: [
    TranslateModule, CommonModule, RouterOutlet, NgxLoadingModule, SpeedDialModule,
    MainMenuComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = 'ih-payment-gateway';
  currentDate = new Date();

  languages: MenuItem[] = [
    { id: 'el', icon: 'gr', command: (e) => this.setLanguage(e.item!) },
    { id: 'en', icon: 'en', command: (e) => this.setLanguage(e.item!) },
    { id: 'hr', icon: 'hr', command: (e) => this.setLanguage(e.item!) },
  ];

  language: MenuItem;

  constructor(
    public loadingService: LoadingService,
    private localStorage: LocalStorageService,
    private translate: TranslateService
  ) {
    let lang: MenuItem | null | undefined = null;
    if (!localStorage.hasStoredLanguage()) {
      lang = this.languages.find(l => l.id == this.getBrowserLang());
    } else {
      lang = this.languages.find(l => l.id == localStorage.getLanguage());
    }

    this.language = lang ?? this.languages[0];

    this.translate.use(this.language.id ?? 'el');
  }

  private getBrowserLang() {
    if (navigator.language == "el" || navigator.language == "cy") {
      return "el";
    }

    if (navigator.language == "hr" || navigator.language == "	cs") {
      return "hr";
    }

    return navigator.language;
  }

  setLanguage(lang: MenuItem) {
    this.language = lang;
    this.localStorage.setLanguage(this.language.id ?? 'el');
  }
}

